import {API, FieldOptions, Steps} from "../common/constants/constants";
import FormInput from "../common/components/FormInput";
import {ApplicantDataInterface} from "../common/interfaces/ApplicantDataInterface";
import {applicantFields} from "../common/constants/applicantFields";
import {FieldInterface} from "../common/interfaces/FieldInterface";
import {ContactPersonDataInterface} from "../common/interfaces/ContactPersonDataInterface";
import {FormSelect} from "../common/components/FormSelect";
import {contactPersonFields} from "../common/constants/contactPersonFields";
import {NotificationDataInterface} from "../common/interfaces/NotificationDataInterface";
import FormTextArea from "../common/components/FormTextArea";
import {notificationFields} from "../common/constants/notificationFields";
import {useEffect, useState} from "react";
import {GeneralDataInterface} from "../common/interfaces/GeneralDataInterface";
import {CompleteReportResultItemInterface} from "../common/interfaces/CompleteReportResultItemInterface";
import {submitNotificationData} from "../common/utils/submitNotificationData";
import {Buttons} from "../common/components/Buttons";

interface Props {
    step: string
    generalData: GeneralDataInterface
    setStep: (step: string) => void
    applicantData: ApplicantDataInterface
    setApplicantData: (data: ApplicantDataInterface) => void
    contactPersonData: ContactPersonDataInterface
    setContactPersonData: (data: ContactPersonDataInterface) => void
    notificationData: NotificationDataInterface
    setNotificationData: (data: NotificationDataInterface) => void,
    setLoading: (loading: boolean) => void
}


const ReportDataView = (props: Props) => {

    const {
        step,
        generalData,
        applicantData,
        setApplicantData,
        contactPersonData,
        setContactPersonData,
        notificationData,
        setNotificationData,
        setLoading,
        setStep
    } = props

    const applicantFieldsDisabled = step === Steps.CONFIRM

    if (step == Steps.LOCATION || step === Steps.CONFIRMED) {
        return null;
    }

    const [environments, setEnvironments] = useState<CompleteReportResultItemInterface[]>([])
    const [locations, setLocations] = useState<CompleteReportResultItemInterface[]>([])
    const [parts, setParts] = useState<CompleteReportResultItemInterface[]>([])
    const [defects, setDefects] = useState<CompleteReportResultItemInterface[]>([])

    useEffect(() => {

        if (environments?.length || !generalData.apiReference) {
            return
        }

        setLoading(true)

        setEnvironments([])
        setNotificationData({...notificationData, environment: null})
        setLocations([])
        setNotificationData({...notificationData, location: null})
        setParts([])
        setNotificationData({...notificationData, part: null})
        setDefects([])
        setNotificationData({...notificationData, defect: null})

        const fetchData = async () => {

            const response = await submitNotificationData({
                areaNumber: generalData.apiReference,
                problemTypeReference: ''
            })

            setEnvironments(response)
            setLoading(false)
        }

        fetchData().catch(console.error)

    }, [generalData.apiReference])

    useEffect(() => {

        setLoading(true)

        if (!notificationData.environment || !notificationData.environment['Heeft onderliggende']) {
            return
        }
        setLocations([])
        setNotificationData({...notificationData, location: null})
        setParts([])
        setNotificationData({...notificationData, part: null})
        setDefects([])
        setNotificationData({...notificationData, defect: null})
        const fetchData = async () => {

            const response = await submitNotificationData({
                areaNumber: generalData.apiReference,
                problemTypeReference: notificationData.environment.Referentie
            })

            setLocations(response)
            setLoading(false)
        }

        fetchData().catch(console.error)

    }, [notificationData.environment]);

    useEffect(() => {

        setLoading(true)

        if (!notificationData.location || !notificationData.location['Heeft onderliggende']) {
            return
        }

        const fetchData = async () => {

            const response = await submitNotificationData({
                areaNumber: generalData.apiReference,
                problemTypeReference: notificationData.location.Referentie
            })

            setParts(response)
            setLoading(false)
        }

        fetchData().catch(console.error)

    }, [notificationData.location]);

    useEffect(() => {

        setLoading(true)

        if (!notificationData.part || !notificationData.part['Heeft onderliggende']) {
            return
        }

        const fetchData = async () => {

            const response = await submitNotificationData({
                areaNumber: generalData.apiReference,
                problemTypeReference: notificationData.part.Referentie
            })

            setDefects(response)
            setLoading(false)
        }

        fetchData().catch(console.error)

    }, [notificationData.part]);


    const applicantFieldsItems = applicantFields(applicantData, setApplicantData, applicantFieldsDisabled)
    const contactPersonFieldsItems = contactPersonFields(contactPersonData, setContactPersonData, applicantFieldsDisabled)
    const notificationFieldsItems = notificationFields({
        notificationData,
        setNotificationData,
        disabled: applicantFieldsDisabled,
        environments: environments,
        locations: locations,
        parts: parts,
        defects: defects
    })

    return (
        <>
            <form onSubmit={(event) => {
                event.preventDefault()
                setStep(Steps.CONFIRM)
            }}>
                <div className={'c-applicant-data'}>

                    <h2 className="p-repair-form__title">Aanvrager gegevens</h2>

                    <div className={'c-applicant-data__inputs'}>
                        {applicantFieldsItems.map((field: FieldInterface) => {
                            return <FormInput {...field} />
                        })}
                    </div>

                    <div className={'c-applicant-data__contact-person'}>

                        <FormSelect
                            label={'Is de contactpersoon niet de aanvrager?'}
                            name={'contactPersonNotRequestPerson'}
                            value={contactPersonData.isActive}
                            onChange={() => {
                                setContactPersonData({
                                    ...contactPersonData,
                                    isActive: !contactPersonData.isActive
                                })
                            }}
                            disabled={applicantFieldsDisabled}
                            required={true}
                            options={
                                [
                                    {value: true, label: 'Ja'},
                                    {value: false, label: 'Nee'}
                                ]
                            }
                        />

                        <div className={'c-applicant-data__contact-person__inputs'}>
                            {contactPersonData.isActive && contactPersonFieldsItems.map((field: FieldInterface) => {
                                return <FormInput {...field} />
                            })}
                        </div>
                    </div>
                </div>

                <div className={'c-notification-data'}>

                    <h2 className="p-repair-form__title">Meldingsgegevens</h2>

                    <div className={'c-notification-data__inputs'}>
                        {notificationFieldsItems.map((field: FieldInterface) => {
                            if (field.type === 'textArea') {
                                return <FormTextArea {...field} />
                            }
                            return <FormSelect {...field} />
                        })}
                    </div>
                </div>

                <Buttons
                    backButton={{
                        text: 'terug',
                        onClick: () => setStep(Steps.LOCATION),
                        disabled: false
                    }}
                    nextButton={{
                        text: 'volgende',
                        disabled: applicantFieldsDisabled
                    }}
                    hide={step !== Steps.REPORT_DATA}
                />

            </form>
        </>
    )
}


export default ReportDataView